// extracted by mini-css-extract-plugin
export default {"modal":"Loading_modal__pLmms","slide-down":"Loading_slide-down__wkcjR"};